function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.58 6.5l5.2-5.19a.79.79 0 000-1.09.79.79 0 00-1.09 0L6.5 5.42 1.31.22a.79.79 0 00-1.09 0 .79.79 0 000 1.09l5.2 5.19-5.2 5.19a.79.79 0 000 1.09.77.77 0 00.55.22.76.76 0 00.54-.22l5.19-5.2 5.19 5.2a.79.79 0 001.09 0 .79.79 0 000-1.09z",
  fill: "currentColor"
});

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13"
  }, props), _ref);
};

export default SvgClose;